import { render, staticRenderFns } from "./ProductRecommendationsCardSmall.vue?vue&type=template&id=7d2bb082&scoped=true&"
import script from "./ProductRecommendationsCardSmall.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendationsCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendationsCardSmall.vue?vue&type=style&index=0&id=7d2bb082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2bb082",
  null
  
)

export default component.exports